export const environment = {
    production: true,
    apiURL: 'https://alpha.api.umedicu.com'
};
